module.exports = __webpack_public_path__ + "img/TRY.2f76aa2a.svg";